const OFFICE_ADDRESS = '31 Walnut Ave, Bellmawr, NJ 08031';

const ContactMap = () => {
  // Google Maps embed URL for the office location
  const embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.234567890123!2d-75.085274!3d39.864712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c8a8a8a8a8a8%3A0x1234567890abcdef!2s${encodeURIComponent(OFFICE_ADDRESS)}!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus`;

  return (
    <div className="w-full h-64 md:h-96 rounded-xl overflow-hidden" style={{ zIndex: 1 }}>
      <iframe
        src={embedUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Map showing ${OFFICE_ADDRESS}`}
      />
    </div>
  );
};

export default ContactMap;
